import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NoComments } from "../../SocialFeeds/styles";
import { ContainerMain } from "../../common/commonStyles";
import { ReportHeading } from "../../UserProfile/styles";
import { BackArrowFeed } from "../../../utils/icons";
import { NewCardContainer } from "../../MainEvents/OnDemandDetailsPage/style";
import { fetchApi } from "../../../utils/methods";
import { GetCompanyOrganizedEventCategoryId } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { t } from "i18next";
import OndemandCard from "./OndemandCard";

const CompanyOrganizedLibrary = ({ history }) => {

  const[onHover,setOnHover] = useState(-1);
  const[ondemandByIdData,setOndemandByIdData] = useState([])
  const [loading, setLoading] = useState(false);
  const [templateId, setTemplateId] = useState(null);


  const onEnterMouse = (id) => {
    setOnHover(id);
  };
    
  const onLeaveMouse = () => {
    setOnHover(-1);
  };

  useEffect(()=>{
    const StringArray = history.location.pathname.split("/");
    setTemplateId(StringArray[StringArray.length - 1]);
    fetchCompanyOrganizedCatgoryId(StringArray[StringArray.length - 1]);
  },[])




  const fetchCompanyOrganizedCatgoryId = async(id)=>{
    setLoading(true); 
    const res = await fetchApi(`${GetCompanyOrganizedEventCategoryId}/${id}`);

    if(res.status === 'success'){
      setOndemandByIdData(res.data)
      setLoading(false); 
    }else{
      toast.error(res?.data?.message)
      setLoading(false); 
    }
  }



  return (
    <>
      <ContainerMain>
        <div className="content-wrap">
          <ReportHeading>
            <div className="icon" onClick={() => history.push("/company/events/library")}>
              {BackArrowFeed()}
            </div>
            <div className="title">{history?.location?.state?.category}</div>
          </ReportHeading>
    
          <NewCardContainer topMargin={"topMargin"}>

            {loading ? (
              <NoComments>Loading...</NoComments> 
            ):ondemandByIdData?.length === 0 ? (
              <NoComments>
                {t("No theme events available for this category.")}
              </NoComments>
            ) : (
              ondemandByIdData?.length > 0 &&
              ondemandByIdData?.map((video, index) => (
                <OndemandCard
                  key={index}
                  video={video}
                  history={history}
                  grid={0}
                  //   link={link}
                  onEnterMouse={onEnterMouse}
                  onLeaveMouse={onLeaveMouse}
                  onHover={onHover}
                  length={index}
                  isCompanyOraganizedEvent={true}
                  templateId={templateId} 
                  fetchCompanyOrganizedCatgoryId={fetchCompanyOrganizedCatgoryId}
                />
              ))
            )}
          </NewCardContainer>
        </div>
      </ContainerMain>
    </>
  );
};

CompanyOrganizedLibrary.propTypes = {
  ondemandByIdData: PropTypes.array,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  link: PropTypes.string,
  onEnterMouse: PropTypes.func,
  onLeaveMouse: PropTypes.func,
  onHover: PropTypes.number,
};

export default CompanyOrganizedLibrary;